module.exports = __webpack_public_path__ + "assets-cabinet/img/add-contact-icon.27d707fe.svg";